
import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

import Period from '../../../../helpers/PeriodWeighted';
import WeightedItem from '../../../../helpers/WeightedTime'

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import RefreshIcon from '@material-ui/icons/Refresh';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';

import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Switch from '@material-ui/core/Switch';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import HelpIcon from '@material-ui/icons/Help';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';
import {getWeighing} from '../../../../services/getWeighing'
import PerfectScrollbar from 'react-perfect-scrollbar';
import AvailabilityWeighted from './AvailabilityWeighted'
import ResponseWeighted from './ResponseWeighted'
import { api_auth} from '../../../../common/globals/constants';
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'
import { getDay } from 'date-fns';
import { func } from 'prop-types';
moment.locale('es')

var range="Rango: "+(moment().locale('es')).format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD")
var rangePonderado="Periodo: "+(moment().locale('es')).subtract(1, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY")
class Weighted extends Component {
    
    constructor(props) {
        //console.log(sessionStorage.getItem("client_id"))
        //console.log("Rango: "+ (moment().locale('es')).format("YYYY-MM-DD"))
        //console.log("Rango: "+ (moment().locale('es')).subtract(1, "days").format("YYYY-MM-DD"))
        //console.log(props)
        super(props);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        //this.handleDateMoment = this.handleDateMoment.bind(this);
        this.state = {
            typeGraph: 0,
            client:sessionStorage.getItem("client_id"),
            token:sessionStorage.getItem("key"),
            period: "d",
            begin:(moment().subtract(1, "days").locale('es')).format("YYYY-MM-DD"),
            final:(moment().locale('es')).format("YYYY-MM-DD"),
            steps: this.props.location.state.fromObjective.Pasos,
            namePeriod: range,
            namePonderado:rangePonderado,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: ['Disponibilidad:POR HORA y Resumen Ponderado','Tiempo de Respuesta:RESUMEN POR HORA' ],
            namePeriodPorlet: ['Último Día', 'Última Semana', 'Custom', 'Últimos 3 Días'],
            typePeriod: 0,
            settingsEl: null,
            settingsPop:null,
            settingWeighted:null,
            isInfo: null,
            detalleGraph:['  Corresponde a la disponibilidad Consolidada Ponderada del objetivo durante el período y horario seleccionado',
                        'Corresponde al rendimiento Consolidado Ponderado del objetivo durante el período y horario seleccionado' ],
            isLoad:true
        };
    }


    componentDidMount() {
        this.getPonderacion()
    }

    getPonderacion=()=>{
        const {token, client}=this.state
        //console.log(api_auth)
        var getWeight=getWeighing(client, token, api_auth)
        
        getWeight.then( value =>{
            var weighted=(value.slice(1,30))
            var weightedId=(value.slice(0,1))[0]
            //console.log(weightedId)
            //value=(value.filter((ele) => ele !== "ponderado_id"))
            //console.log(value)
            this.setState({
                Weighing:weighted,
                weightedId:weightedId,
                isLoad:false   
            });
        })
        
    }
    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        //console.log(nextPeriod)
        if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 0,
                begin:(moment().subtract(1, "days").locale('es')).format("YYYY-MM-DD"),
                final:(moment().locale('es')).format("YYYY-MM-DD"),
                namePeriod: "Rango: "+(moment().locale('es')).format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                namePonderado: "Periodo: "+(moment().locale('es')).subtract(1, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 3,
                begin:(moment().subtract(3, "days").locale('es')).format("YYYY-MM-DD"),
                final:(moment().locale('es')).format("YYYY-MM-DD"),
                namePeriod: "Rango: "+(moment().locale('es')).subtract(3, "days").format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                namePonderado: "Periodo: "+(moment().locale('es')).subtract(3, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 1,
                begin:(moment().subtract(7, "days").locale('es')).format("YYYY-MM-DD"),
                final:(moment().locale('es')).format("YYYY-MM-DD"),
                namePeriod: "Rango: "+(moment().locale('es')).subtract(1, "weeks").format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                namePonderado: "Periodo: "+(moment().locale('es')).subtract(1, "weeks").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            //console.log(statePeriod.startDate.toISOString().substring(0, 10),statePeriod.endDate.toISOString().substring(0, 10) )
            function sumarDias(fecha, dias){
                fecha.setDate(fecha.getDate() + dias);
                return fecha;
            }
            function restaDias(fecha, dias){
                fecha.setDate(fecha.getDate() - dias);
                return fecha;
            }
            var sumaDiaPerio = statePeriod.endDate;
            var diaActual = new Date();
            if(statePeriod.startDate.toISOString().substring(0, 10) == diaActual.toISOString().substring(0, 10)){
                this.setState({
                    typeGraph: prevTypeGraph,
                    period: "d",
                    typePeriod: 0,
                    begin:(moment().subtract(1, "days").locale('es')).format("YYYY-MM-DD"),
                    final:(moment().locale('es')).format("YYYY-MM-DD"),
                    namePeriod: "Rango: "+(moment().locale('es')).format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                    namePonderado: "Periodo: "+(moment().locale('es')).subtract(1, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                    statePeriod: {},
                    isStatePeriod: false,
                    periodEl: null,
                    isRefresh: false
                });
            }
            else if(statePeriod.startDate.toISOString().substring(0, 10) == statePeriod.endDate.toISOString().substring(0, 10)){
                sumarDias(sumaDiaPerio, 1);
                this.setState({
                    typeGraph: prevTypeGraph,
                    period: "c",
                    begin:statePeriod.startDate.toISOString().substring(0, 10),
                    final:statePeriod.endDate.toISOString().substring(0, 10),
                    typePeriod: 2,
                    namePeriod: 'Rango: ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                    namePonderado: "Periodo: "+ new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(statePeriod.startDate) + ' al ' + new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(restaDias(sumaDiaPerio, 1)),
                    statePeriod: statePeriod,
                    isStatePeriod: true,
                    periodEl: null,
                    isRefresh: false
                });
            }else{
                sumarDias(sumaDiaPerio, 1);
                this.setState({
                    typeGraph: prevTypeGraph,
                    period: "c",
                    begin:statePeriod.startDate.toISOString().substring(0, 10),
                    final:statePeriod.endDate.toISOString().substring(0, 10),
                    typePeriod: 2,
                    namePeriod: 'Rango: ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                    namePonderado: "Periodo: "+ new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(statePeriod.startDate) + ' al ' + new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(restaDias(sumaDiaPerio, 1)),
                    statePeriod: statePeriod,
                    isStatePeriod: true,
                    periodEl: null,
                    isRefresh: false
                });
            }
        }
    }

    handleModalWeighted =event=>{
        this.setState({
            settingWeighted: event.currentTarget
        });
    }
    handleModalCloseWeighted = () => {
        this.setState({
            settingWeighted: null
        });
    };
    handlePopGraph = event => {
        this.setState({
            settingsPop: event.currentTarget
        });
    };
    handleClosePop = () => {
        this.setState({
            settingsPop: null
        });
    };
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowAvailability=()=>{
        this.setState({
            typeGraph: 0,
            settingsPop: null
        });
    }

    handleShowResponse=()=>{
        this.setState({
            typeGraph: 1,
            settingsPop: null
        });
    }

    handleClose = event => {

        this.props.onClose()
	};


    render() {
        const { classes } = this.props;
        const { typeGraph, period, namePeriod,namePonderado , periodEl, nameGraph, namePeriodPorlet,
            typePeriod, extendEl, settingsEl, isInfo, detalleGraph, begin, final, isLoad, settingsPop, settingWeighted} = this.state;

        const showSettingsPop = Boolean(settingsPop);
        const showSettingsWeighted = Boolean(settingWeighted);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        //console.log(classes.portletFooter)
        if(isLoad===true){
            return (
                <PortletContent>
                    <PerfectScrollbar style={{position:"static"}}>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            )
            
        }else{
            return (

                <Portlet
                        /*  {...rest} */
                        className={classes.rootClassName}
                    >
                        <PortletHeader className={classes.header}
                        >
                            <PortletLabel
                                item
                                xs={8}
                                sm={8}
                                md={8}
                                xl={8}
                                /*  icon={<DevicesIcon />} */
                                variant="h6"
                                title={ nameGraph[typeGraph]}
                            />

                            <PortletToolbar>
                                {/*<IconButton
                                    
                                    onClick={this.handleModalWeighted}
                                >
                                    <Typography color="primary"
                                    variant="h5">PONDERACIÓN </Typography>
                                    <ArrowRightIcon />                                    
                                </IconButton>*/}

                                <Popover
                                    anchorEl={settingWeighted}
                                    onClose={this.handleModalCloseWeighted}
                                    open={showSettingsWeighted}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                        }}
                                    >
                                    <WeightedItem weighted={this.state.Weighing} idWeighted={this.state.weightedId} />
                                </Popover>



                                <IconButton
                                    item
                                    xs={2}
                                    sm={2}
                                    md={2}
                                    xl={2}
                                    onClick={this.handlePopGraph}
                                >
                                    <Typography color="infoIcon"
                                    variant="h5">TABLAS </Typography>
                                    <ArrowRightIcon />                                    
                                </IconButton>
                                
                                <Popover
                                    
                                    anchorEl={settingsPop}
                                    onClose={this.handleClosePop}
                                    open={showSettingsPop}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                        }}
                                        
                                    >
                                    <Grid container direction="column"  alignItems="center" >
                                        <Grid item xs={12} xl={12}>
                                            <IconButton
                                                onClick={this.handleShowAvailability}
                                                //onClose={this.handleCloseAvailability}
                                            >
                                                <Typography variant="h6">Disponibilidad</Typography>
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={12} xl={12}>
                                            <IconButton
                                                onClick={this.handleShowResponse}
                                                //onClose={this.handleCloseResponse}
                                            >
                                                <Typography variant="h6">Rendimiento</Typography>
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Popover>




                                <IconButton
                                    //className={classes.refreshButton}
                                    //variant="text"
                                    item
                                    xs={1}
                                    sm={1}
                                    md={1}
                                    xl={1}
                                    onClick={this.handleShowSettings}
                                >
                                    <SettingsOutlinedIcon />
                                    
                                </IconButton>
                                <Popover
                                    anchorEl={settingsEl}
                                    onClose={this.handleCloseSettings}
                                    open={showSettingsEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                        }}
                                    >
                                    {/*<IconButton
                                        className={classes.refreshButton}
                                        variant="text"
                                        onClick={this.handleRefresh}
                                        onClose={this.handleCloseSettings}
                                    >
                                        <div>
                                            <RefreshIcon color="primary" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>
                                        </div>
                                    </IconButton>*/}
                                    <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <HelpIcon color="secondary"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Información</Typography>
                                        </div>
                                    </IconButton>
                                        <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{detalleGraph[typeGraph]}</PortletContent>
                                    </Popover>
                                    {/*<Tooltip title="Actualización Automatica cada 5 minutos">
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        </div>
                                    </Tooltip>*/}
                                </Popover>
                            </PortletToolbar>
                            <Grid
                                item
                                xs={1}
                                sm={1}
                                md={1}
                                xl={1}
                                className={classes.buttonClosed}
                                >
                                <IconButton key="close" aria-label="close" className={classes.buttonClosed} onClick={this.handleClose}><CloseIcon/></IconButton>
                            </Grid>
                        </PortletHeader>
                        <PortletContent className={classes.content}>
                            <Grid
                                container
                                spacing={10}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}
                                    style={{padding:"35px"}}>
                                    <PerfectScrollbar >
                                    <Grid container direction="row"  alignItems="center" >
                                        <Grid item xs={12} xl={12}>
                                            <Graph typeGraph={typeGraph} data={this.state} />
                                        </Grid>
                                        {/*<Grid  item xs={12} xl={12}>
                                            <Grid container direction="row"  alignItems="center">
                                                <Grid  item xs={1} xl={1} style={{paddingLeft:"30px"}}>
                                                    <Avatar variant="rounded" className={classes.rounded}>
                                                        <UpdateIcon /> 
                                                    </Avatar>
                                                </Grid>
                                                <Grid  item xs={11} xl={11}>
                                                    <Typography  className={classes.updateTime}   >
                                                        &nbsp; Última actualización: {dateMoment} 
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>*/}
                                    </Grid>            
                                    </PerfectScrollbar>
                                </Grid>
                            </Grid>
                            
                        </PortletContent>
                        
                        <PortletFooter>
                            <Grid container direction="row"  alignItems="center">
                                <Grid  item xs={6} xl={6}>
                                    <Button   onClick={this.handleShowPeriod}>
                                        <Typography style={{float:'left', color:'#66788A', fontWeight:"bold"}} varian="caption">
                                            {namePeriodPorlet[typePeriod]}
                                        </Typography>
                                        <ArrowDropDownIcon />
                                    </Button>
                                    <Popover
                                        anchorEl={periodEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center'
                                        }}
                                        onClose={this.handleClosePeriod}
                                        open={showPeriodEl}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center'
                                        }}>
                                        <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={null}/>
                                    </Popover>
                                </Grid>
                                <Typography style={{float:'right', color:'#66788A', fontWeight:"bold"}} varian="caption">
                                            {namePonderado}
                                </Typography>
                            
                            </Grid>
                            
                        </PortletFooter>
                    </Portlet>
            )
        }
    }
}

function Graph(props) {
    //console.log('props envio', props.data)
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {    
        return <AvailabilityWeighted period={props.data.typePeriod} objective={props.data.objetive} steps={props.data.steps} begin={props.data.begin} 
        final={props.data.final} range={props.data.range} namePeriod={props.data.period} Weighing={props.data.Weighing}/>;
    }else if (typeGraph === 1) {    
        return <ResponseWeighted period={props.data.typePeriod} objective={props.data.objetive} steps={props.data.steps} begin={props.data.begin} 
        final={props.data.final} range={props.data.range} namePeriod={props.data.period} Weighing={props.data.Weighing}/>;
    }
}
export default
    compose(withRouter, withStyles(styles))(Weighted);